import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

// Get all course requests
const getCourseRequests = async () => {
  const response = await axios.get(`${base_url}course-request/`, config);
  return response.data;
};

// Delete a course request
const deleteCourseRequest = async (id) => {
  const response = await axios.delete(`${base_url}course-request/${id}`, config);
  return response.data;
};

// Get a single course request by ID
const getCourseRequest = async (id) => {
  const response = await axios.get(`${base_url}course-request/${id}`, config);
  return response.data;
};

// Update a course request (e.g., change status or details)
const updateCourseRequest = async (courseRequest) => {
  const response = await axios.put(
    `${base_url}course-request/${courseRequest.id}`,
    { status: courseRequest.status, details: courseRequest.details },
    config
  );
  return response.data;
};

// Get unread course requests
const getUnreadCourseRequests = async () => {
  const response = await axios.get(`${base_url}course-request/unread`, config);
  return response.data;
};

// Mark a course request as read
const markCourseRequestAsRead = async (id) => {
  const response = await axios.put(
    `${base_url}course-request/${id}/mark-as-read`,
    {},
    config
  );
  return response.data;
};

// Submit feedback for a course request
const submitFeedback = async ({ id, email, userName, feedback, staffMember }) => {
  const response = await axios.post(
    `${base_url}course-request/feedback`,
    { id, email, userName, feedback, staffMember },
    config
  );
  return response.data;
};

const courseRequestService = {
  getCourseRequests,
  deleteCourseRequest,
  getCourseRequest,
  updateCourseRequest,
  getUnreadCourseRequests,
  markCourseRequestAsRead,
  submitFeedback,
};

export default courseRequestService;
